export const COLLECTOR = {
    pushInterval: 5000,
}